import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Container, i18n } from '../../../../symphony';

import kodieButtonAnim from './assets/kodie-button-anim.json';
import { SlLEContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

import s from './Kodie.scss';
import { KodieIcon } from '../../../../shared/public/assets/icons/KodieIcon';

export function OpenButton({ onClick }: { onClick: () => void }) {
	useStyles(s);
	const { actions$ } = Container.take(SlLEContext, SlActions);
	const {
		kodieIntroIsClosed$: kodieIntroIsClosed,
		isKodieInNavigationAnimationShowed$: isKodieInNavigationAnimationShowed,
	} = useContainerData(SlLEContext, SlDataService, [
		'kodieIntroIsClosed$',
		'isKodieInNavigationAnimationShowed$',
	]);
	const [isAnimationVisible, setIsAnimationVisible] = useState(false);

	useEffect(() => {
		if (kodieIntroIsClosed && !isKodieInNavigationAnimationShowed) {
			setTimeout(() => {
				setIsAnimationVisible(true);
				actions$.next({
					type: ActionType.OnKodieInNavigationAnimationEnd,
					requestType: RequestType.Parallel,
				});
			}, 483);
		}
	}, [kodieIntroIsClosed, isKodieInNavigationAnimationShowed]);

	return (
		<div
			onClick={onClick}
			className={`le-kodie__open-button${
				isAnimationVisible ? ' animation' : ''
			}`}
		>
			{!isAnimationVisible ? (
				<>
					<KodieIcon />
					{i18n.t('web-le.lesson-nav-kodie-button')}
				</>
			) : (
				<Lottie animationData={kodieButtonAnim} autoPlay loop={false} />
			)}
		</div>
	);
}
